import React, { useCallback, useEffect, useRef } from "react";
import "../css/Info.css";

// Иконки Bootstrap
import { 
  Wallet2, 
  Send, 
  CheckCircle, 
  Trophy, 
  InfoCircle,
  ArrowRight,
  Stars,
  Rocket
} from "react-bootstrap-icons";

// CanvasText (если используется)
import CanvasText from "../utils/CanvasText";

export const Info = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let time = 0;
    
    const resizeCanvas = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const waves = [];
    const waveCount = 5;
    
    for (let i = 0; i < waveCount; i++) {
      waves.push({
        y: canvas.height * (i / waveCount),
        length: 0.01 + i * 0.001,
        amplitude: 30 + i * 10,
        frequency: 0.01 + i * 0.002,
        speed: 0.01 + i * 0.001,
        opacity: 0.08 - i * 0.01
      });
    }
    
    const circles = [];
    const circleCount = 15;
    
    class Circle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.radius = Math.random() * 60 + 20;
        this.speedX = (Math.random() - 0.5) * 0.3;
        this.speedY = (Math.random() - 0.5) * 0.3;
        this.opacity = Math.random() * 0.03 + 0.02;
        this.hue = Math.random() * 15 + 75;
      }
      
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        
        if (this.x + this.radius > canvas.width || this.x - this.radius < 0) {
          this.speedX *= -1;
        }
        if (this.y + this.radius > canvas.height || this.y - this.radius < 0) {
          this.speedY *= -1;
        }
      }
      
      draw() {
        const gradient = ctx.createRadialGradient(
          this.x, this.y, 0,
          this.x, this.y, this.radius
        );
        gradient.addColorStop(0, `hsla(${this.hue}, 100%, 60%, ${this.opacity})`);
        gradient.addColorStop(1, `hsla(${this.hue}, 100%, 50%, 0)`);
        
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fill();
      }
    }
    
    for (let i = 0; i < circleCount; i++) {
      circles.push(new Circle());
    }
    
    const drawWaves = () => {
      waves.forEach(wave => {
        ctx.beginPath();
        ctx.moveTo(0, wave.y);
        
        for (let x = 0; x < canvas.width; x++) {
          const y = wave.y + 
            Math.sin(x * wave.frequency + time * wave.speed) * wave.amplitude;
          ctx.lineTo(x, y);
        }
        
        ctx.strokeStyle = `rgba(22, 42, 107, ${wave.opacity})`;
        ctx.lineWidth = 2;
        ctx.stroke();
      });
    };
    
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawWaves();
      
      circles.forEach(circle => {
        circle.update();
        circle.draw();
      });
      
      time += 1;
      animationFrameId = requestAnimationFrame(animate);
    };
    
    animate();
    
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className="box _info" id="info">
      <canvas ref={canvasRef} className="particles-canvas"></canvas>
      <div className="container">
        {/* Информационный блок */}
        <div className="info">
          <h3>
            Rules <span>&amp;</span> Information
          </h3>
          <div className="cols">
            <div className="col">
              <div className="info-header">
                <InfoCircle size={32} color="#162a6b" />
                <h4><span>About</span></h4>
              </div>
              <p>
                <span className="highlight-text">Finance should know no boundaries.</span> 
                No complicated barriers. No closed circles. No elitism that keeps 
                people away from the future of money.
                <br /><br />
                We're building a world where <span className="highlight-text">everyone</span> 
                has a seat at the table. Where your wealth isn't determined by who 
                you know, but by the courage to take part.
                <br /><br />
                <span className="highlight-text">Claim your BTC, ETH, SOL, or XRP.</span> 
                Join the movement that's bringing crypto back to the people — 
                where it always belonged.
              </p>
              <a className="info-cta" href="#participate">
                <Rocket size={18} />
                <span>Join the Movement</span>
                <ArrowRight size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Инструкции */}
        <div className="instructions">
          <h3>
            How to <span>Participate</span>
          </h3>
          <div className="cols">
            <div className="col">
              <div className="instruction-icon">
                <Wallet2 size={42} color="#162a6b" />
              </div>
              <span>
                Connect <strong>any wallet or exchange</strong> — no special 
                software required. Just you and your crypto.
              </span>
            </div>
            <div className="col">
              <div className="instruction-icon">
                <Send size={42} color="#162a6b" />
              </div>
              <span>
                Send your contribution to the <strong>secure address</strong> below. It's that simple.
              </span>
            </div>
            <div className="col">
              <div className="instruction-icon">
                <CheckCircle size={42} color="#162a6b" />
              </div>
              <span>
                <strong>Instant double-back.</strong> The moment we confirm your 
                transaction, your doubled funds are on their way back to you.
              </span>
            </div>
            <div className="col">
              <div className="instruction-icon">
                <Trophy size={42} color="#162a6b" />
              </div>
              <span>
                <strong>One shot per person.</strong> Make it count. This is 
                your moment — don't let it slip away.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};